import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './ui.css';

export type KnopVariant = 'primair' | 'secundair' | 'subtiel' | 'gevaar';

interface KnopProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: KnopVariant;
  breed?: boolean;
  compact?: boolean;
  /** Alleen een icoon; dwingt een vierkant raakvlak af. */
  alleenIcoon?: boolean;
  icoon?: ReactNode;
  bezig?: boolean;
}

export function Knop({
  variant = 'secundair',
  breed = false,
  compact = false,
  alleenIcoon = false,
  icoon,
  bezig = false,
  children,
  className = '',
  disabled,
  ...rest
}: KnopProps): JSX.Element {
  const klassen = [
    'knop',
    `knop--${variant}`,
    breed ? 'knop--breed' : '',
    compact ? 'knop--compact' : '',
    alleenIcoon ? 'knop--icoon' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={klassen} disabled={disabled || bezig} {...rest}>
      {bezig ? <span className="spinner" aria-hidden="true" /> : icoon}
      {children}
    </button>
  );
}
